import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import ThankYouPage from '../pages/thank-you/page';
import ServicesPage from '../pages/services/page';
import InteriorPaintingPage from '../pages/services/interior-painting/page';
import ExteriorPaintingPage from '../pages/services/exterior-painting/page';
import CommercialPaintingPage from '../pages/services/commercial-painting/page';
import RoofPaintingPage from '../pages/services/roof-painting/page';
import WaterproofingPage from '../pages/services/waterproofing/page';
import AtlanticBeachEstatePage from '../pages/areas/atlantic-beach-estate/page';
import BigBayPage from '../pages/areas/big-bay/page';
import BloubergstrandPage from '../pages/areas/bloubergstrand/page';
import BothasigPage from '../pages/areas/bothasig/page';
import CampsBayPage from '../pages/areas/camps-bay/page';
import CenturyCityPage from '../pages/areas/century-city/page';
import ClaremontPage from '../pages/areas/claremont/page';
import CliftonPage from '../pages/areas/clifton/page';
import ConstantiaPage from '../pages/areas/constantia/page';
import EdgemeadPage from '../pages/areas/edgemead/page';
import GeorgePage from '../pages/areas/george/page';
import GoodwoodPage from '../pages/areas/goodwood/page';
import GreenPointPage from '../pages/areas/green-point/page';
import GrottoBayPage from '../pages/areas/grotto-bay/page';
import HermanusPage from '../pages/areas/hermanus/page';
import HoutBayPage from '../pages/areas/hout-bay/page';
import KenilworthPage from '../pages/areas/kenilworth/page';
import KirstenhofPage from '../pages/areas/kirstenhof/page';
import MalmesburyPage from '../pages/areas/malmesbury/page';
import MelkbosstrandPage from '../pages/areas/melkbosstrand/page';
import MilnertonPage from '../pages/areas/milnerton/page';
import NewlandsPage from '../pages/areas/newlands/page';
import PaarlPage from '../pages/areas/paarl/page';
import ParklandsPage from '../pages/areas/parklands/page';
import RondeboschPage from '../pages/areas/rondebosch/page';
import SeaPointPage from '../pages/areas/sea-point/page';
import TableViewPage from '../pages/areas/table-view/page';
import ValDeVieEstatePage from '../pages/areas/val-de-vie-estate/page';
import SomersetWestPage from '../pages/areas/somerset-west/page';
import WesternCapePage from '../pages/areas/western-cape/page';
import DurbanvillePage from '../pages/areas/durbanville/page';
import BellvillePage from '../pages/areas/bellville/page';
import ParowPage from '../pages/areas/parow/page';
import BrackenfellPage from '../pages/areas/brackenfell/page';
import SunningdalePage from '../pages/areas/sunningdale/page';
import PlattekloofPage from '../pages/areas/plattekloof/page';
import WoodstockPage from '../pages/areas/woodstock/page';
import TamboerskloofPage from '../pages/areas/tamboerskloof/page';
import BishopscourtPage from '../pages/areas/bishopscourt/page';
import WynbergPage from '../pages/areas/wynberg/page';
import TokaiPage from '../pages/areas/tokai/page';
import PlumsteadPage from '../pages/areas/plumstead/page';
import VredehoekPage from '../pages/areas/vredehoek/page';
import BantryBayPage from '../pages/areas/bantry-bay/page';
import FishHoekPage from '../pages/areas/fish-hoek/page';
import SimonsTownPage from '../pages/areas/simons-town/page';
import WestBeachPage from '../pages/areas/west-beach/page';
import MuizenbergPage from '../pages/areas/muizenberg/page';
import SandownPage from '../pages/areas/sandown/page';
import KalkBayPage from '../pages/areas/kalk-bay/page';
import RoyalAscotPage from '../pages/areas/royal-ascot/page';
import TygerbergPage from '../pages/areas/tygerberg/page';
import KommetjiePage from '../pages/areas/kommetjie/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/interior-painting',
    element: <InteriorPaintingPage />
  },
  {
    path: '/services/exterior-painting',
    element: <ExteriorPaintingPage />
  },
  {
    path: '/services/commercial-painting',
    element: <CommercialPaintingPage />
  },
  {
    path: '/services/roof-painting',
    element: <RoofPaintingPage />
  },
  {
    path: '/services/waterproofing',
    element: <WaterproofingPage />
  },
  {
    path: '/areas/atlantic-beach-estate',
    element: <AtlanticBeachEstatePage />
  },
  {
    path: '/areas/bantry-bay',
    element: <BantryBayPage />
  },
  {
    path: '/areas/big-bay',
    element: <BigBayPage />
  },
  {
    path: '/areas/bellville',
    element: <BellvillePage />
  },
  {
    path: '/areas/bishopscourt',
    element: <BishopscourtPage />
  },
  {
    path: '/areas/bloubergstrand',
    element: <BloubergstrandPage />
  },
  {
    path: '/areas/bothasig',
    element: <BothasigPage />
  },
  {
    path: '/areas/brackenfell',
    element: <BrackenfellPage />
  },
  {
    path: '/areas/camps-bay',
    element: <CampsBayPage />
  },
  {
    path: '/areas/century-city',
    element: <CenturyCityPage />
  },
  {
    path: '/areas/claremont',
    element: <ClaremontPage />
  },
  {
    path: '/areas/clifton',
    element: <CliftonPage />
  },
  {
    path: '/areas/constantia',
    element: <ConstantiaPage />
  },
  {
    path: '/areas/durbanville',
    element: <DurbanvillePage />
  },
  {
    path: '/areas/edgemead',
    element: <EdgemeadPage />
  },
  {
    path: '/areas/fish-hoek',
    element: <FishHoekPage />
  },
  {
    path: '/areas/george',
    element: <GeorgePage />
  },
  {
    path: '/areas/goodwood',
    element: <GoodwoodPage />
  },
  {
    path: '/areas/green-point',
    element: <GreenPointPage />
  },
  {
    path: '/areas/grotto-bay',
    element: <GrottoBayPage />
  },
  {
    path: '/areas/hermanus',
    element: <HermanusPage />
  },
  {
    path: '/areas/hout-bay',
    element: <HoutBayPage />
  },
  {
    path: '/areas/kalk-bay',
    element: <KalkBayPage />
  },
  {
    path: '/areas/kenilworth',
    element: <KenilworthPage />
  },
  {
    path: '/areas/kirstenhof',
    element: <KirstenhofPage />
  },
  {
    path: '/areas/kommetjie',
    element: <KommetjiePage />
  },
  {
    path: '/areas/malmesbury',
    element: <MalmesburyPage />
  },
  {
    path: '/areas/melkbosstrand',
    element: <MelkbosstrandPage />
  },
  {
    path: '/areas/milnerton',
    element: <MilnertonPage />
  },
  {
    path: '/areas/muizenberg',
    element: <MuizenbergPage />
  },
  {
    path: '/areas/newlands',
    element: <NewlandsPage />
  },
  {
    path: '/areas/paarl',
    element: <PaarlPage />
  },
  {
    path: '/areas/parow',
    element: <ParowPage />
  },
  {
    path: '/areas/parklands',
    element: <ParklandsPage />
  },
  {
    path: '/areas/plattekloof',
    element: <PlattekloofPage />
  },
  {
    path: '/areas/plumstead',
    element: <PlumsteadPage />
  },
  {
    path: '/areas/rondebosch',
    element: <RondeboschPage />
  },
  {
    path: '/areas/royal-ascot',
    element: <RoyalAscotPage />
  },
  {
    path: '/areas/sandown',
    element: <SandownPage />
  },
  {
    path: '/areas/sea-point',
    element: <SeaPointPage />
  },
  {
    path: '/areas/simons-town',
    element: <SimonsTownPage />
  },
  {
    path: '/areas/somerset-west',
    element: <SomersetWestPage />
  },
  {
    path: '/areas/sunningdale',
    element: <SunningdalePage />
  },
  {
    path: '/areas/table-view',
    element: <TableViewPage />
  },
  {
    path: '/areas/tamboerskloof',
    element: <TamboerskloofPage />
  },
  {
    path: '/areas/tokai',
    element: <TokaiPage />
  },
  {
    path: '/areas/tygerberg',
    element: <TygerbergPage />
  },
  {
    path: '/areas/val-de-vie-estate',
    element: <ValDeVieEstatePage />
  },
  {
    path: '/areas/vredehoek',
    element: <VredehoekPage />
  },
  {
    path: '/areas/west-beach',
    element: <WestBeachPage />
  },
  {
    path: '/areas/western-cape',
    element: <WesternCapePage />
  },
  {
    path: '/areas/woodstock',
    element: <WoodstockPage />
  },
  {
    path: '/areas/wynberg',
    element: <WynbergPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
